import React from 'react';
import { Project } from '../types/Project';
import './ProjectDetailPanel.css';

interface ProjectDetailPanelProps {
  project: Project;
  onClose: () => void;
}

const ProjectDetailPanel: React.FC<ProjectDetailPanelProps> = ({ project, onClose }) => {
  console.log('ProjectDetailPanel is rendering for project:', project.title);
  const previewImages = project.images.slice(0, 3);

  return (
    <div className="project-detail-overlay">
      <div className="project-detail-panel">
        <div className="project-detail-header">
          {project.logoUrl && (
            <img
              src={project.logoUrl}
              alt={`${project.title} logo`}
              className="project-detail-header-logo"
              style={{
                height: '4.5rem',
                width: 'auto',
                marginRight: '1rem',
                objectFit: 'contain',
                filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.3))'
              }}
            />
          )}
          <div className="project-detail-header-text">
            <span className="project-detail-eyebrow">Exploration</span>
            <h2 className="project-detail-title">{project.title}</h2>
          </div>
          <button className="project-detail-close" type="button" onClick={onClose}>
            Quitter
          </button>
        </div>

        <p className="project-detail-description">{project.description}</p>

        {project.technologies.length > 0 && (
          <section className="project-detail-section">
            <h3 className="project-detail-section-title">Stack technique</h3>
            <div className="project-detail-chip-row">
              {project.technologies.map((tech) => (
                <span key={tech} className="project-detail-chip">
                  {tech}
                </span>
              ))}
            </div>
          </section>
        )}

        {previewImages.length > 0 && (
          <section className="project-detail-section">
            <h3 className="project-detail-section-title">Aperçus</h3>
            <div className="project-detail-image-grid">
              {previewImages.map((image, index) => (
                <div key={image} className="project-detail-image-wrapper">
                  <img src={image} alt={`${project.title} aperçu ${index + 1}`} />
                </div>
              ))}
            </div>
          </section>
        )}

        {(project.liveUrl || project.githubUrl || project.isPrivate || project.isUniversity || project.id === 'sun-profile') && (
          <div className="project-detail-actions">
            {project.id === 'sun-profile' ? (
              <>
                <a className="project-detail-primary" href="/cv.pdf" target="_blank" rel="noreferrer">
                  Mon CV
                </a>
                {project.liveUrl && (
                  <a className="project-detail-secondary" href={project.liveUrl} target="_blank" rel="noreferrer">
                    LinkedIn
                  </a>
                )}
                {project.githubUrl && (
                  <a className="project-detail-secondary" href={project.githubUrl} target="_blank" rel="noreferrer">
                    <img src="https://cdn.simpleicons.org/github" alt="GitHub" style={{ width: '1.2rem', height: '1.2rem', filter: 'invert(1)' }} />
                  </a>
                )}
              </>
            ) : (
              <>
                {project.liveUrl && (
                  <a className="project-detail-primary" href={project.liveUrl} target="_blank" rel="noreferrer">
                    Voir en ligne
                  </a>
                )}
                {project.isUniversity ? (
                  <div className="project-detail-secondary" style={{ cursor: 'default', opacity: 0.9, borderColor: '#3498db', color: '#3498db' }} aria-label="Projet Universitaire">
                    <span style={{ marginRight: '0.5rem', fontSize: '1.2rem' }}>🎓</span>
                    <span>Projet Universitaire</span>
                  </div>
                ) : project.isPrivate ? (
                  <div className="project-detail-secondary" style={{ cursor: 'default', opacity: 0.8 }} aria-label="Projet privé">
                    <span style={{ marginRight: '0.5rem', fontSize: '1.1rem' }}>🔒</span>
                    <span>Private</span>
                  </div>
                ) : project.githubUrl && (
                  <a className="project-detail-secondary" href={project.githubUrl} target="_blank" rel="noreferrer" aria-label="Voir le code source">
                    <img src="https://cdn.simpleicons.org/github" alt="GitHub" style={{ width: '1.2rem', height: '1.2rem', filter: 'invert(1)' }} />
                  </a>
                )}
              </>
            )}
          </div>
        )}


        <button className="project-detail-close-mobile" type="button" onClick={onClose}>
          Fermer
        </button>
      </div>
    </div>
  );
};

export default ProjectDetailPanel;
